<template>
  <div
    class="row pt-1"
    v-if="berechtigungen.m_bildung.read"
  >
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>Modulunterricht</span>
          </div>
          <div class="body">
            <div class="row">
              <!-- <div :class="kachelCol">
                <div
                  class="tile-frame h-1"
                  :class="kachelStyle"
                >
                  <router-link :to="{ name: 'tor-liste' }">
                    <div class="tile bg-light-grey-lila inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-file-certificate"
                          transform="left-1 shrink-2"
                        />
                      </div>
                      <div class="title">ToR</div>
                    </div>
                  </router-link>
                </div>
              </div> -->
              <div :class="kachelCol">
                <div
                  class="tile-frame h-1 cursor-pointer"
                  :class="kachelStyle"
                >
                  <router-link
                    :to="{ name: 'promotionsuebersicht-modulunterricht' }"
                  >
                    <div class="tile bg-grey-lila inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-file-certificate"
                          transform="left-1 shrink-2"
                        />
                      </div>
                      <div class="title">Modulunterricht</div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelCol">
                <div
                  class="tile-frame h-1 cursor-pointer"
                  :class="kachelStyle"
                  @click="oeffneMessageBox()"
                >
                  <div class="tile bg-light-grey-lila inverted">
                    <div class="icon-container fa-container">
                      <font-awesome-icon
                        icon="fa-duotone fa-book-arrow-up"
                        transform="shrink-3"
                      />
                    </div>
                    <div class="title">{{ $t('global.transfergrades') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <messagebox-enhanced
      :headerText="$t('global.transfergrades')"
      id="noten-uebernehmen-msgbox"
      :ok="true"
      :cancel="true"
      :okText="$t('global.transfergrades')"
      :cancelText="$t('global.cancel')"
      @ok="notenUebernehmen()"
    />
  </div>
</template>

<script>
  import TorApi from '@/api/TorApi'
  import MessageboxEnhanced from '@/components/Modals/MessageboxEnhanced.vue'
  import { apiErrorToAlert } from '@/utils/Errorhandler'

  export default {
    name: 'StartseiteTor',
    components: { MessageboxEnhanced },
    mixins: [],
    props: {
      kachelStyle: { type: String },
      kachelCol: { type: String },
      kachelKleinStyle: { type: String },
      kachelKleinCol: { type: String },
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    computed: {},
    methods: {
      oeffneMessageBox() {
        this.$bus.$emit('openMessageBoxEnhanced', {
          id: 'noten-uebernehmen-msgbox',
          text: this.$t('global.doyoureallywanttotransfergrades'),
        })
      },
      notenUebernehmen() {
        this.$emit('loading')
        TorApi.post('grades/', {})
          .then(() => {
            this.$notify({
              type: 'success',
              title: this.$t('global.actionsuccessful'),
              text: this.$t('global.gradetransfersuccess'),
            })
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
          })
          .finally(() => {
            this.$emit('stopLoading')
          })
      },
    },
  }
</script>
